const MQ24GSender = {
    uuid: "",
    format: "",
    model: "MQ2-4G",
    updated_at: "",
    sent: {basic: false, advanced: false},
    sent_at: {basic: null, advanced: null},
    ack: {basic: false, advanced: false},
    ack_at: {basic: null, advanced: null},
    command: {basic: "00", advanced: "00"},
    payload: {basic: "", advanced: ""},
    config: {basic: "", advanced: ""},
    state: {basic: "p", advanced: "p"},
};
export default MQ24GSender;
